import Reply from "$components/editor/extensions/blocks/Reply/Reply.svelte";
import { Node } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { NodePasteRule, SvelteSSRRenderer } from "$components/editor/utils";
import { threadURL } from "app/utils/urls";
import { get } from "svelte/store";
import { communitySlug } from "app/stores/community";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export default Node.create({
  name: "reply",
  group: "block",
  draggable: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      forumSpaceSlug: { default: "" },
      forumSpaceUuid: { default: "" },
      threadUuid: { default: "" },
      threadSlug: { default: "" },
      replySeqNum: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: "reply" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("reply", Reply, { node, attributes: HTMLAttributes });
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Reply);
  },
  addPasteRules() {
    return [
      NodePasteRule({
        find: /^(https?:\/\/)?(app\.outverse\.com|localhost:3000|alpha\.outverse\.dev|frontend\.outver\.se|outverse-pip-feature-[0-9a-zA-Z-_]+\.herokuapp\.com)\/([0-9a-zA-Z-_]+)\/community\/forum\/([0-9-a-z-A-Z]+)\/([0-9-a-z-A-Z-_]+)\/([0-9-a-z-A-Z]+)\/([0-9-a-z-A-Z-_]+)?\?post=([0-9]+)$/g,
        type: this.type,
        getAttributes: (match) => ({
          forumSpaceSlug: match[4],
          forumSpaceUuid: match[5],
          threadSlug: match[6],
          threadUuid: match[7],
          replySeqNum: match[8],
        }),
      }),
    ];
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const { forumSpaceSlug, forumSpaceUuid, threadSlug, threadUuid, replySeqNum } =
            node.attrs;
          const url = threadURL({
            communitySlug: get(communitySlug),
            spaceUuid: forumSpaceUuid,
            spaceSlug: forumSpaceSlug,
            threadUuid: threadUuid,
            threadSlug: threadSlug,
          });
          state.write(`[Reply: ${threadSlug}](${url}?post=${replySeqNum})\n\n`);
        },
      },
    };
  },
});
